import { useOuraData } from "../contexts/OuraDataContext";

/**
 * WHAT:
 *   Optimized SpO2 Hook using centralized data context.
 *
 * WHY:
 *   Uses centralized data context instead of making separate API calls.
 *
 * @returns Object containing SpO2 data, error, loading state, average, and breathing disturbance index
 *
 */
export const useOptimizedSpO2 = () => {
  const { error, loading, spo2 } = useOuraData();

  return {
    average: spo2?.average ?? 0,
    breathingDisturbanceIndex: spo2?.breathing_disturbance_index ?? 0,
    error,
    loading,
    spo2,
  };
};
